import { useEffect, useState } from "react";

const useDelayedFlag = (flag: boolean, delayMs: number) => {
  const [elapsed, setElapsed] = useState(false);

  useEffect(() => {
    if (!flag) {
      return;
    }

    const timeout = setTimeout(() => setElapsed(true), delayMs);

    return () => {
      clearTimeout(timeout);
      setElapsed(false);
    };
  }, [flag, delayMs]);

  return flag && elapsed;
};

export default useDelayedFlag;
